import useSeo from "@/hooks/useSeo";

/** Mount point for useSeo — a hook needs a component, and this one renders
 *  nothing so it can sit next to <Routes> without affecting layout. */
export default function SeoHead() {
  useSeo();
  return null;
}
